export default {
  priv: 'pr_manage',
  overviewTitle: 'Artikelen',
  detailTitle: 'Artikel',
  deleteTitle: 'dit artikel',
  url: '/manage/products',
  apiUrl: '/products/',
  sortBy: ['name'],
  sortDesc: [false],
  deletable: true,
  editable: true,
  filterName: 'products',
  quickFilter: {
    text: 'Zoeken',
    value: 'misc_search',
    type: 'text'
  },
  newRecord: {
    vatrate_id: 1
  },
  tableFields: [
    {
      text: 'Artikelnummer',
      value: 'code',
      link: '/manage/products/{id}',
      width: '20%'
    },
    {
      text: 'Omschrijving',
      value: 'description',
      sortable: false,
      width: '20%'
    },
    {
      text: 'Rd',
      value: 'thermal_resistance',
      width: '15%'
    },
    {
      text: 'Eenheidsprijs',
      value: 'unit_price',
      filter: 'euro',
      width: '15%'
    },
    {
      text: 'Eenheid',
      value: 'unittype_short',
      width: '15%'
    }
  ]
};
